e.A.user_photo = {
	init : function(){
		$('#user-image').hide();
		$(document).bind("MVCImageUploadReturn", function( e, url, attachment ){
			e.A.user_photo.changePhoto( attachment.id );
		});

		$('.avatar-option').click( function(){
			e.A.user_photo.chageInputValue($(this).attr('rel'));
			e.A.user_photo.changePhoto($(this).attr('rel'));
		});
	},

	changePhoto : function( id ){
		EdSpireAjax.Request( 'EdSpireAccountSettings', 'ajax_get_user_photo', id, function( src ){
			$('#user-image-placeholder').attr('src',src);
			e.A.user_photo.chageInputValue( src );
		});

	},


	chageInputValue : function(v){
		$('input#user-image').val(v);
	}
	
};